<template>
  <div class="con">
    <div class="con-inner">
      <h2 class="con-head">免责声明</h2>
      <div>
        <div
          v-for="(item, index) in textLines"
          :key="index"
          :class="{ paragraph: item.paragraph, title: item.title }"
        >
          {{ textFilter(item.text) }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      name: "中国机械总院集团武汉材料保护研究所有限公司公共服务平台",
      subName: "公共服务平台",
      textLines: [
        {
          paragraph: true,
          text: `{name}以检验检测服务为主体的工业互联网云平台，本平台声明对如下事宜不承担任何法律责任。`,
        },
        {
          paragraph: true,
          text: `1. 任何情况下通过{name}所发布或链接的所有信息、数据及网页等所导致的损失或损害（包括间接、直接、特别或后果性的损失或损害，如收入或利润之损失，
          电脑系统之损坏或数据丢失等后果）责任均由使用者自行承担，{name}均不承担任何直接或间接的责任。
          基于技术和任何不可预见之原因（如天气、自然灾害等）而导致服务中断或其他任何原因而造成的损失，{name}将不予承担任何责任，用户需自行承担一切直接或间接的法律及法规责任。`,
        },
        {
          paragraph: true,
          text: `2. {name}所发布和提供的内容及服务均由信息及服务提供方所发布，其真实性、准确性、合法性由信息发布提供方负责，发布和提供的内容及服务并不反应本平台之意见及观点。
          因网上交易存在一定风险，{name}上任何因发布方提供的所有内容和服务而产生的任何法律责任均由其自行承担。`,
        },
        {
          paragraph: true,
          text: `3. {name}有权对本声明及一切与本声明相关联的所有附属协议和规则及声明（包括已经和将要发布的）做必要的制定、修改和完善。`,
        },
        {
          paragraph: true,
          text: `4. 在相关法律及法规允许的范围内，{name}将以正常且合理的谨慎原则提供本声明及其相关附属的其他协议和规则项下的服务。`,
        },
        {
          paragraph: true,
          text: `5. 任何情况下{name}不承担所有使用者因使用平台服务与任何第三方因产生纠纷而导致的任何责任，用户应自行判断信息真实性、自主参与交易并承担交易风险。`,
        },
        {
          paragraph: true,
          text: `6. 登录或注册{name}时，您的行为将被视为对{name}免责声明及其相关联和附属的任何协议及规则中全部内容的认可。`,
        },
        {
          paragraph: true,
          text: `7. 本声明适用双方为{name}与所有使用平台服务的用户。`,
        },
      ],
    };
  },
  methods: {
    textFilter(val) {
      return val
        .replaceAll("{name}", this.name)
        .replaceAll("{subName}", this.subName);
    },
  },
};
</script>
<style scoped lang="scss">
@import "./common.scss";
</style>
